export enum PlasticsHardwareItemShipmentStatus {
	Draft = 'Draft',
	Complete = 'Complete',
}